<template>
    <div class="ticket__container">
        <TicketValidationDetail/>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'
import TicketValidationDetail from '@/components/ticket-validation-detail'

export default {
    mixins: [languageMixins],
    components: { TicketValidationDetail },
}
</script>
